// extracted by mini-css-extract-plugin
module.exports = {"nav-panel":"kd","navPanel":"kd","nav-panel-bg":"ke","navPanelBg":"ke","nav-panel-content":"kf","navPanelContent":"kf","none":"kg","block":"kh"};